// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/Internet.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/bg1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/bgabout.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/productImg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.5 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-\\[-85px\\] {
  bottom: -85px;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.z-50 {
  z-index: 50;
}
.mx-\\[6px\\] {
  margin-left: 6px;
  margin-right: 6px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-8 {
  margin-left: 2rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.w-6 {
  width: 1.5rem;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-\\[45\\%\\] {
  width: 45%;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.cursor-pointer {
  cursor: pointer;
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-16 {
  gap: 4rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[40px\\] {
  border-radius: 40px;
}
.rounded-full {
  border-radius: 9999px;
}
.border-\\[0\\.5px\\] {
  border-width: 0.5px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[\\#31373D\\] {
  --tw-border-opacity: 1;
  border-color: rgb(49 55 61 / var(--tw-border-opacity));
}
.border-\\[\\#5A3D8B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(90 61 139 / var(--tw-border-opacity));
}
.bg-\\[\\#5A3D8B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(90 61 139 / var(--tw-bg-opacity));
}
.bg-\\[\\#EB4178\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 65 120 / var(--tw-bg-opacity));
}
.bg-\\[\\#F3F0FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 240 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#d63d7d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(214 61 125 / var(--tw-bg-opacity));
}
.bg-\\[\\#fdfaff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 250 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.from-\\[\\#5b3f8b\\] {
  --tw-gradient-from: #5b3f8b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(91 63 139 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#5a3d8b\\] {
  --tw-gradient-to: #5a3d8b var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-left-top {
  background-position: left top;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-contain {
  object-fit: contain;
}
.p-2 {
  padding: 0.5rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-\\[20px\\] {
  padding: 20px;
}
.p-\\[50px\\] {
  padding: 50px;
}
.\\!py-\\[1px\\] {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-48 {
  padding-top: 12rem;
}
.\\!text-center {
  text-align: center !important;
}
.text-center {
  text-align: center;
}
.\\!text-\\[8px\\] {
  font-size: 8px !important;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[6px\\] {
  font-size: 6px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-\\[900\\] {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-8 {
  line-height: 2rem;
}
.\\!text-\\[\\#5A3D8B\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(90 61 139 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#1D1E20\\] {
  --tw-text-opacity: 1;
  color: rgb(29 30 32 / var(--tw-text-opacity));
}
.text-\\[\\#222\\] {
  --tw-text-opacity: 1;
  color: rgb(34 34 34 / var(--tw-text-opacity));
}
.text-\\[\\#31373D\\] {
  --tw-text-opacity: 1;
  color: rgb(49 55 61 / var(--tw-text-opacity));
}
.text-\\[\\#555E67\\] {
  --tw-text-opacity: 1;
  color: rgb(85 94 103 / var(--tw-text-opacity));
}
.text-\\[\\#585858\\] {
  --tw-text-opacity: 1;
  color: rgb(88 88 88 / var(--tw-text-opacity));
}
.text-\\[\\#5A3D8B\\] {
  --tw-text-opacity: 1;
  color: rgb(90 61 139 / var(--tw-text-opacity));
}
.text-\\[\\#EB4178\\] {
  --tw-text-opacity: 1;
  color: rgb(235 65 120 / var(--tw-text-opacity));
}
.text-\\[\\#d63d7d\\] {
  --tw-text-opacity: 1;
  color: rgb(214 61 125 / var(--tw-text-opacity));
}
.text-\\[green\\] {
  --tw-text-opacity: 1;
  color: rgb(0 128 0 / var(--tw-text-opacity));
}
.text-\\[red\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline-offset-4 {
  text-underline-offset: 4px;
}

body,
html,
* {
  margin: 0;
  padding: 0;
  font-family: 'Montserrat', sans-serif;
}

.font-satoshi {
  font-family: 'Montserrat', sans-serif;
}

.font-dmsans {
  font-family: 'Montserrat', sans-serif;
}

.bg-hero {
  /* background-image: url('assets/hero.svg'); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
}

.bg-hero1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.bg-about {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.bg-productImg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.bg-\\[background-position-x\\:-150px\\] {
  background-position-x: -150px;
}

.bg-\\[background-position-y\\:-60px\\] {
  background-position-y: -60px;
}

:root {
  --swiper-navigation-size: 24px !important;
}

.myswiperbox .swiper-button-prev {
  top: 10% !important;
  left: 89% !important;
}

.myswiperbox .swiper-button-next {
  top: 10% !important;
  right: 5% !important;
}

.mySwiper .swiper-button-next,
.swiper-button-prev {
  z-index: 20 !important;
  cursor: pointer;
}

.myswiperbox .swiper-button-next:after,
.myswiperbox .swiper-rtl .swiper-button-prev:after,
.myswiperbox .swiper-button-prev:after,
.myswiperbox .swiper-rtl .swiper-button-next:after {
  content: '' !important;
}

.myswiperbox .swiper-horizontal > .swiper-pagination-bullets,
.myswiperbox .swiper-pagination-bullets.swiper-pagination-horizontal,
.myswiperbox .swiper-pagination-custom,
.myswiperbox .swiper-pagination-fraction {
  bottom: auto !important;
}

.parallax-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 105%;
  height: 100%;
  background-size: cover;
  background-position: bottom right;
}

.swiper-slide .title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #555e67;
}

.swiper-slide .text {
  font-size: 18px;
  max-width: 400px;
  line-height: 1.3;
  margin-bottom: 2rem;
}

.swiper-wrapper {
  display: flex;
}

.mySwiper .swiper-wrapper {
  display: flex;
  align-items: center;
}

.mySwiper .swiper-button-prev {
  top: 95% !important;
  left: 43% !important;
}

.mySwiper .swiper-button-next {
  top: 95% !important;
  right: 43% !important;
}

.mySwiper .text {
  max-width: 50%;
  line-height: 30px;
}

.mySwiper .title {
  font-size: 25px;
}

/* Mobile */
@media (max-width: 800px) {
  .mySwiper .swiper-button-prev {
    top: 95% !important;
    left: 33% !important;
  }

  .mySwiper .swiper-button-next {
    top: 95% !important;
    right: 33% !important;
  }

  .myswiperbox .swiper-button-prev {
    top: 10% !important;
    left: 88% !important;
  }

  .myswiperbox .swiper-button-next {
    top: 10% !important;
    right: 5% !important;
  }

  .swiper-slide .title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 1rem;
    color: #222;
  }

  .swiper-slide .text {
    font-size: 13px;
    max-width: 400px;
    line-height: 1.3;
    color: #222;
  }

  .parallax-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 250%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }
}

.htmlServices {
  width: 100%;
  height: 100%;
  background: #efefef;
  position: absolute;
}

/* .button {
  position: absolute;
} */

.button--left {
  left: 40%;
  top: 98%;
  /* transform: translateX(-200px); */
}

.button--right {
  right: 40%;
  top: 98%;
  /* transform: translateX(300px); */
}

.carousel {
  height: 50%;
  padding: 0;
  margin: 0;
  position: absolute;
  left: 36%;
  top: 50%;
  transform: translate3d(-50%, -40%, 0);
}

.item {
  height: 150px;
  width: 400px;
  background: #f3f0ff;
  float: left;
  list-style: none;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transform-style: preserve-3d;
  transition: all 0.5s ease;
  border-radius: 10px;
}

.item:last-child {
  margin-right: 0;
}

[data-position='1'] {
  transform: scale(1.5) translate3d(-105px, 0px, 0px);
  z-index: 1;
}
[data-position='3'] {
  transform: scale(2) translate3d(0px, 0px, 0px);
  z-index: 3;
}

[data-position='2'] {
  transform: scale(1.5) translate3d(105px, 0px, -5px);
  z-index: 1;
}

@keyframes crossfade {
  0% {
    opacity: 1;
  }
  5% {
    opacity: 0.7;
  }
  10% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

/* Mobile */
@media (max-width: 450px) {
  .myswiperbox .swiper-button-prev {
    left: 82% !important;
  }
  .item {
    width: 145px;
  }
  [data-position='1'] {
    transform: scale(1.5) translate3d(-38px, 0px, 0px);
  }
  [data-position='3'] {
    transform: scale(2) translate3d(0px, 0px, 0px);
  }

  [data-position='2'] {
    transform: scale(1.5) translate3d(38px, 0px, -5px);
  }
  .carousel {
    left: 30%;
    top: 60%;
    transform: translate3d(-50%, -40%, 0);
  }
  .button--left {
    left: 32%;
    top: 113%;
  }

  .button--right {
    right: 32%;
    top: 113%;
  }
}

@media (max-width: 900px) {
  .bg-\\[background-position-x\\:-150px\\] {
    background-position-x: 0;
  }

  .bg-\\[background-position-y\\:-60px\\] {
    background-position-y: 0px;
  }
}

.hover\\:bg-gradient-to-b:hover {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.hover\\:from-\\[\\#5a3d8b\\]:hover {
  --tw-gradient-from: #5a3d8b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(90 61 139 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-\\[\\#5b3f8b\\]:hover {
  --tw-gradient-to: #5b3f8b var(--tw-gradient-to-position);
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-40:hover {
  opacity: 0.4;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

@media (min-width: 1024px) {

  .lg\\:bottom-\\[-10px\\] {
    bottom: -10px;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .lg\\:mt-14 {
    margin-top: 3.5rem;
  }

  .lg\\:mt-16 {
    margin-top: 4rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[150px\\] {
    height: 150px;
  }

  .lg\\:h-\\[25px\\] {
    height: 25px;
  }

  .lg\\:h-\\[419px\\] {
    height: 419px;
  }

  .lg\\:h-\\[50px\\] {
    height: 50px;
  }

  .lg\\:h-\\[850px\\] {
    height: 850px;
  }

  .lg\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .lg\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .lg\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:gap-x-10 {
    column-gap: 2.5rem;
  }

  .lg\\:rounded-\\[20px\\] {
    border-radius: 20px;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-20 {
    padding: 5rem;
  }

  .lg\\:p-5 {
    padding: 1.25rem;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .lg\\:px-\\[50px\\] {
    padding-left: 50px;
    padding-right: 50px;
  }

  .lg\\:py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .lg\\:pt-16 {
    padding-top: 4rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-center {
    text-align: center;
  }

  .lg\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .lg\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .lg\\:text-\\[50px\\] {
    font-size: 50px;
  }

  .lg\\:text-\\[56px\\] {
    font-size: 56px;
  }

  .lg\\:text-\\[8px\\] {
    font-size: 8px;
  }

  .lg\\:leading-\\[70px\\] {
    line-height: 70px;
  }

  .lg\\:text-\\[\\#000\\] {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;CAA0B;;AAA1B;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,4NAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;AAC1B;EAAA;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;;AAI/B;;;EAGE,SAAS;EACT,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,yDAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,yDAAuC;AACzC;;AAEA;EACE,yDAA2C;AAC7C;;AAEA;EACE,yDAA8C;AAChD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EAEZ,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IAEZ,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,SAAS;EACT,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mDAAmD;EACnD,UAAU;AACZ;AACA;EACE,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,WAAW;AACX;EACE;IACE,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,kDAAkD;EACpD;EACA;IACE,8CAA8C;EAChD;;EAEA;IACE,kDAAkD;EACpD;EACA;IACE,SAAS;IACT,QAAQ;IACR,qCAAqC;EACvC;EACA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,UAAU;IACV,SAAS;EACX;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAjTA;EAAA;AAkTA;;AAlTA;EAAA,4DAkTA;EAlTA,mEAkTA;EAlTA;AAkTA;;AAlTA;EAAA;AAkTA;;AAlTA;EAAA;AAkTA;;AAlTA;EAAA;AAkTA;;AAlTA;EAAA;AAkTA;;AAlTA;EAAA,8BAkTA;EAlTA;AAkTA;;AAlTA;;EAAA;IAAA;EAkTA;;EAlTA;IAAA,gBAkTA;IAlTA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA,iBAkTA;IAlTA;EAkTA;;EAlTA;IAAA,kBAkTA;IAlTA;EAkTA;;EAlTA;IAAA,kBAkTA;IAlTA;EAkTA;;EAlTA;IAAA,kBAkTA;IAlTA;EAkTA;;EAlTA;IAAA,iBAkTA;IAlTA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA;EAkTA;;EAlTA;IAAA,oBAkTA;IAlTA;EAkTA;AAAA","sourcesContent":["@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');\n\nbody,\nhtml,\n* {\n  margin: 0;\n  padding: 0;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.font-satoshi {\n  font-family: 'Montserrat', sans-serif;\n}\n\n.font-dmsans {\n  font-family: 'Montserrat', sans-serif;\n}\n\n.bg-hero {\n  /* background-image: url('assets/hero.svg'); */\n  background-image: url('assets/Internet.png');\n  background-position: center;\n}\n\n.bg-hero1 {\n  background-image: url('assets/bg1.svg');\n}\n\n.bg-about {\n  background-image: url('assets/bgabout.svg');\n}\n\n.bg-productImg {\n  background-image: url('assets/productImg.svg');\n}\n\n.bg-\\[background-position-x\\:-150px\\] {\n  background-position-x: -150px;\n}\n\n.bg-\\[background-position-y\\:-60px\\] {\n  background-position-y: -60px;\n}\n\n:root {\n  --swiper-navigation-size: 24px !important;\n}\n\n.myswiperbox .swiper-button-prev {\n  top: 10% !important;\n  left: 89% !important;\n}\n\n.myswiperbox .swiper-button-next {\n  top: 10% !important;\n  right: 5% !important;\n}\n\n.mySwiper .swiper-button-next,\n.swiper-button-prev {\n  z-index: 20 !important;\n  cursor: pointer;\n}\n\n.myswiperbox .swiper-button-next:after,\n.myswiperbox .swiper-rtl .swiper-button-prev:after,\n.myswiperbox .swiper-button-prev:after,\n.myswiperbox .swiper-rtl .swiper-button-next:after {\n  content: '' !important;\n}\n\n.myswiperbox .swiper-horizontal > .swiper-pagination-bullets,\n.myswiperbox .swiper-pagination-bullets.swiper-pagination-horizontal,\n.myswiperbox .swiper-pagination-custom,\n.myswiperbox .swiper-pagination-fraction {\n  bottom: auto !important;\n}\n\n.parallax-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 105%;\n  height: 100%;\n  -webkit-background-size: cover;\n  background-size: cover;\n  background-position: bottom right;\n}\n\n.swiper-slide .title {\n  font-size: 28px;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: #555e67;\n}\n\n.swiper-slide .text {\n  font-size: 18px;\n  max-width: 400px;\n  line-height: 1.3;\n  margin-bottom: 2rem;\n}\n\n.swiper-wrapper {\n  display: flex;\n}\n\n.mySwiper .swiper-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.mySwiper .swiper-button-prev {\n  top: 95% !important;\n  left: 43% !important;\n}\n\n.mySwiper .swiper-button-next {\n  top: 95% !important;\n  right: 43% !important;\n}\n\n.mySwiper .text {\n  max-width: 50%;\n  line-height: 30px;\n}\n\n.mySwiper .title {\n  font-size: 25px;\n}\n\n/* Mobile */\n@media (max-width: 800px) {\n  .mySwiper .swiper-button-prev {\n    top: 95% !important;\n    left: 33% !important;\n  }\n\n  .mySwiper .swiper-button-next {\n    top: 95% !important;\n    right: 33% !important;\n  }\n\n  .myswiperbox .swiper-button-prev {\n    top: 10% !important;\n    left: 88% !important;\n  }\n\n  .myswiperbox .swiper-button-next {\n    top: 10% !important;\n    right: 5% !important;\n  }\n\n  .swiper-slide .title {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 1rem;\n    color: #222;\n  }\n\n  .swiper-slide .text {\n    font-size: 13px;\n    max-width: 400px;\n    line-height: 1.3;\n    color: #222;\n  }\n\n  .parallax-bg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 250%;\n    height: 100%;\n    -webkit-background-size: cover;\n    background-size: cover;\n    background-position: center;\n  }\n}\n\n.htmlServices {\n  width: 100%;\n  height: 100%;\n  background: #efefef;\n  position: absolute;\n}\n\n/* .button {\n  position: absolute;\n} */\n\n.button--left {\n  left: 40%;\n  top: 98%;\n  /* transform: translateX(-200px); */\n}\n\n.button--right {\n  right: 40%;\n  top: 98%;\n  /* transform: translateX(300px); */\n}\n\n.carousel {\n  height: 50%;\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  left: 36%;\n  top: 50%;\n  transform: translate3d(-50%, -40%, 0);\n}\n\n.item {\n  height: 150px;\n  width: 400px;\n  background: #f3f0ff;\n  float: left;\n  list-style: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-transform-style: preserve-3d;\n  transition: all 0.5s ease;\n  border-radius: 10px;\n}\n\n.item:last-child {\n  margin-right: 0;\n}\n\n[data-position='1'] {\n  transform: scale(1.5) translate3d(-105px, 0px, 0px);\n  z-index: 1;\n}\n[data-position='3'] {\n  transform: scale(2) translate3d(0px, 0px, 0px);\n  z-index: 3;\n}\n\n[data-position='2'] {\n  transform: scale(1.5) translate3d(105px, 0px, -5px);\n  z-index: 1;\n}\n\n@keyframes crossfade {\n  0% {\n    opacity: 1;\n  }\n  5% {\n    opacity: 0.7;\n  }\n  10% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/* Mobile */\n@media (max-width: 450px) {\n  .myswiperbox .swiper-button-prev {\n    left: 82% !important;\n  }\n  .item {\n    width: 145px;\n  }\n  [data-position='1'] {\n    transform: scale(1.5) translate3d(-38px, 0px, 0px);\n  }\n  [data-position='3'] {\n    transform: scale(2) translate3d(0px, 0px, 0px);\n  }\n\n  [data-position='2'] {\n    transform: scale(1.5) translate3d(38px, 0px, -5px);\n  }\n  .carousel {\n    left: 30%;\n    top: 60%;\n    transform: translate3d(-50%, -40%, 0);\n  }\n  .button--left {\n    left: 32%;\n    top: 113%;\n  }\n\n  .button--right {\n    right: 32%;\n    top: 113%;\n  }\n}\n\n@media (max-width: 900px) {\n  .bg-\\[background-position-x\\:-150px\\] {\n    background-position-x: 0;\n  }\n\n  .bg-\\[background-position-y\\:-60px\\] {\n    background-position-y: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
